import React from "react";
type ProductListItemsBodyProps = React.ClassAttributes<HTMLDivElement> & React.HTMLAttributes<HTMLDivElement>

export default function ProductListItemsBody({ children, className, ...props }: ProductListItemsBodyProps) {
  return (
    <div className={`h-[100%] bg-white p-4 ${className}`} {...props}>
      {children}


    </div>
  )
}